import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/earningsCalculator";
import { useAppDispatch, useAppSelector } from "../../../store";
import { ABOLegBody, addABOLeg } from "../../../reducers/earningCalculator";
import { addABOLegTrack } from "../../../common/tealium/EarningCalculator/EarningCalculatorTrack";
import EarningsCalculatorABOLeg from "./EarningsCalculatorABOLeg/EarningsCalculatorABOLeg";
import EarningsCalculatorAddABOLegTile from "./EarningsCalculatorABOLeg/EarningsCalculatorAddABOLegTile/EarningsCalculatorAddABOLegTile";
import "./EarningsCalculatorABOLegs.scss";

type Props = {
  IsLoading: boolean;
  disableInput?: boolean;
};

const EarningsCalculatorABOLegs = (props: Props) => {
  const { t } = useTranslation(["earningsCalculator"]);
  const dispatch = useAppDispatch();

  const { IsLoading, disableInput = false } = props;
  const { ABOLegs, ECComputedData } = useAppSelector((state: any) => state.earningCalculator);
  const { Settings } = ECComputedData;
  const { MaxLegs, Min, Max, Marks, Labels } = Settings.ABOLegs;

  const defaultABOLeg = {
    Removeable: true,
    AffABO: "",
    Name: {
      ABOName: "",
      ABOLocalName: "",
      ISOLanguage: "",
      PrivacyFlag: false,
    },
    GroupPV: 0,
  };

  const _ABOLegs = ABOLegs.length === 0 && IsLoading ? [defaultABOLeg] : ABOLegs;

  const gpvLabel = `${t("aboLegs.legTile.gpv", defaultContent["aboLegs"]["legTile"]["gpv"])}`;
  const translatedMark = Marks.map((mark: any) => ({ ...mark, Label: mark.Label === "GPV" ? gpvLabel : mark.Label }));

  const handleAddLeg = () => {
    addABOLegTrack();
    dispatch(addABOLeg());
  };

  return (
    <div className="earnings-calculator-abo-legs">
      {_ABOLegs.map((aboLeg: ABOLegBody, index: number) => (
        <EarningsCalculatorABOLeg
          key={index}
          IsLoading={IsLoading}
          ABOLeg={aboLeg}
          LegCount={index}
          Marks={translatedMark}
          Labels={Labels}
          Min={Min}
          Max={Max}
          CountryCode={Settings.BonusSchedule.ISOCountry}
          disableInput={disableInput}
        />
      ))}
      {ABOLegs.length < MaxLegs && <EarningsCalculatorAddABOLegTile IsLoading={IsLoading} Onclick={handleAddLeg} />}
    </div>
  );
};

export default EarningsCalculatorABOLegs;
